export default {
  namespaced: true,

  state: {
    account: {
      value: 'mdi-account',
    },
    'account-subscription': {
      value: 'mdi-account-check',
    },
    'account-group': {
      value: 'mdi-account-group',
    },
    'account-lock': {
      value: 'mdi-account-lock',
    },
    'account-multiple-check': {
      value: 'mdi-account-multiple-check',
    },
    'account-multiple-plus': {
      value: 'mdi-account-multiple-plus',
    },
    'account-show': {
      value: 'mdi-account-eye',
    },
    'application-outline': {
      value: 'mdi-application-outline',
    },

    'arrow-u-left-top': {
      value: 'mdi-arrow-u-left-top',
    },

    domain: {
      value: 'mdi-domain',
    },
    default: {
      value: 'mdi-star',
    },
    carousel: {
      value: 'mdi-view-carousel-outline',
    },
    chat: {
      value: 'mdi-message-text-outline',
    },
    check: {
      value: 'mdi-check-bold',
    },
    circle: {
      value: 'mdi-circle',
    },
    'check-circle': {
      value: 'mdi-check-circle',
    },
    'close-circle': {
      value: 'mdi-close-circle',
    },
    clock: {
      value: 'mdi-clock-time-three-outline',
    },
    'clock-time-five': {
      value: 'mdi-clock-time-five',
    },
    close: {
      value: 'mdi-close',
    },
    collapse: {
      value: 'mdi-arrow-collapse',
    },
    'content-save-move': {
      value: 'mdi-content-save-move',
    },
    delete: {
      value: 'mdi-delete',
    },
    download: {
      value: 'mdi-download',
    },
    edit: {
      value: 'mdi-pencil',
    },
    expand: {
      value: 'mdi-arrow-expand',
    },
    eye: {
      value: 'mdi-eye',
    },
    folder: {
      value: 'mdi-folder-open-outline',
      close: 'mdi-folder-outline',
    },
    help: {
      value: 'mdi-help-circle',
    },
    history: {
      value: 'mdi-history',
    },
    information: {
      value: 'mdi-information',
    },
    logout: {
      value: 'mdi-logout',
    },
    magnify: {
      value: 'mdi-magnify',
    },
    'menu-down': {
      value: 'mdi-menu-down',
    },
    'map-market': {
      value: 'mdi-map-marker',
    },
    messenger: {
      value: 'mdi-file-document-edit-outline',
    },
    microphone: {
      value: 'mdi-microphone',
    },
    minus: {
      value: 'mdi-minus',
    },
    'minus-circle': {
      value: 'mdi-minus-circle',
    },
    'office-building': {
      value: 'mdi-office-building',
    },
    plus: {
      value: 'mdi-plus',
    },
    'plus-circle': {
      value: 'mdi-plus-circle',
    },
    qsmart: {
      value: 'mdi-text-box-search',
    },
    reload: {
      value: 'mdi-reload',
    },
    reset: {
      value: 'mdi-autorenew',
    },
    rooms: {
      value: 'mdi-file-tree',
    },
    send: {
      value: 'mdi-send',
    },
    'system-messages': {
      value: 'mdi-message-cog-outline',
    },
    'timer-outline': {
      value: 'mdi-timer-outline',
    },
    today: {
      value: 'mdi-calendar-today',
    },
    month: {
      value: 'mdi-calendar-month',
    },
    upload: {
      value: 'mdi-upload',
    },
    whatsapp: {
      value: 'mdi-whatsapp',
    },
    email: {
      value: 'mdi-email',
    },
    'arrow-left': {
      value: 'mdi-arrow-left',
    },
    'arrow-right': {
      value: 'mdi-arrow-right',
    },
    'face-agent': {
      value: 'mdi-face-agent',
    },
    'face-man': {
      value: 'mdi-face-man',
    },
    'chart-box': {
      value: 'mdi-chart-box-outline',
    },
    dashboard: {
      value: 'mdi-view-dashboard-outline',
    },
    alert: {
      value: 'mdi-alert-circle',
    },
  },
};
